import { useSelector } from 'react-redux'
import { notifAudioView } from '$logic/notif-audio/storage'

export function useNotifAudio() {
  return useSelector(state => notifAudioView(state) || { muted: false })
}
